import { SVGProps } from "react";

export const Cross = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M15.4812 1.00889L0.99311 15.7261C0.855879 15.8655 0.686154 15.9605 0.521274 15.9902C0.356394 16.0198 0.209865 15.9817 0.113921 15.8843C0.0179772 15.7868 -0.0195217 15.638 0.00967332 15.4705C0.0388684 15.303 0.132366 15.1306 0.269598 14.9912L14.7577 0.273934C14.895 0.134532 15.0647 0.0395556 15.2296 0.00989885C15.3944 -0.0197579 15.541 0.0183345 15.6369 0.115796C15.7329 0.213257 15.7704 0.362103 15.7412 0.52959C15.712 0.697078 15.6185 0.869487 15.4812 1.00889Z" />
      <path d="M15.0067 15.7235L0.516161 1.00865C0.378906 0.869272 0.285393 0.696891 0.256193 0.529431C0.226993 0.361971 0.264498 0.213149 0.360458 0.115704C0.456418 0.0182586 0.602972 -0.0198272 0.767879 0.0098247C0.932787 0.0394766 1.10254 0.134437 1.2398 0.273817L15.7304 14.9887C15.8676 15.128 15.9611 15.3004 15.9903 15.4679C16.0195 15.6354 15.982 15.7842 15.8861 15.8816C15.7901 15.9791 15.6435 16.0171 15.4786 15.9875C15.3137 15.9578 15.144 15.8629 15.0067 15.7235Z" />
    </svg>
  );
};
